import "./style.scss";
import { useInitialConfigStore } from "../../storeModules/useInitialConfigStore";

const BotButton = ({
  style = "default",
  text = "Button",
  size = "small",
  enabled = false,
  onClick = () => {},
}) => {
  const { primaryBackground, primaryForeground } = useInitialConfigStore(
    (state) => state.setThemeColors
  );

  return (
    <button
      onClick={() => onClick()}
      className={`button ${enabled ? "" : "button--disabled"} ${
        style === "outlined" ? "button--outlined" : ""
      }`}
      style={{
        backgroundColor:
          primaryBackground && style !== "outlined" && enabled
            ? primaryBackground
            : "",
        color: primaryForeground && enabled ? primaryForeground : "",
        border: style === "outlined" ? `2px solid ${primaryBackground}` : "",
      }}
    >
      {text}
    </button>
  );
};

export default BotButton;
